var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-nav"},[_c('ul',{staticClass:"titleList"},_vm._l((_vm.subNavList),function(item,index){return _c('li',{key:index,class:{ active: _vm.selected == index },on:{"click":function($event){return _vm.changeTab(index)}}},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_c('span')])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }